import React from 'react'
import PageLayout from 'components/PageLayout'
import Seo from 'components/Seo'
import RecaptchaScripts from 'components/RecaptchaScripts'
import FormSection from 'components/SellWithFlip/FormSection'
import MagicHeader from 'components/newMagic/MagicHeader'

const ContactPage = () => (
  <PageLayout hideFooter className="beatrice-font">
    <Seo title="Start Selling on Flip" />
    <RecaptchaScripts />
    <MagicHeader />
    <FormSection />
  </PageLayout>
)

export default ContactPage
